/** Backend error codes that have a translation under the `API_ERRORS` i18n namespace. */
export const TRANSLATED_API_ERROR_CODES: ReadonlyArray<string> = ['EMPLOYEE_UNDER_AGE'];

export const API_ERRORS_TRANSLATION_PREFIX = 'API_ERRORS';
